import React from 'react';

import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Card,
  Typography,
} from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import {
  Inventory as ArchiveIcon,
  MoveToInbox as InboxIcon,
  ElectricRickshawSharp as TicketControlIcon,
  PinSharp as SerialControlTicket,
  TransferWithinAStationSharp as TechnicalControlIcon,
  Info as DashboardControlIcon,
  ManageHistory as TechTicketsIcon,
  PeopleAlt as UsersIcon,
  Category as ConstantsIcon,
  PropaneTank as ConsumablesIcon,
  CurrencyExchange as PayrollReport,
  AddTask as InstallReport,
  QueryStats as SparesReport,
  AddToDrive as BulkReport,
  SupportAgent as TicketingReport,
} from '@mui/icons-material/';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../StaticContent/Multilayer-aht-logo.png';

import './navStyling.css';
//import { themeOptions as Theme } from "./theme";

//Side nav bar component
function MainNavBar() {
  const navRestrictions = {};
  const navigate = useNavigate();
  let location = useLocation();

  //List of possible menu items
  const fields = [
    {
      key: 'notice',
      text: 'Noticeboard',
      path: '/',
      icon: <DashboardControlIcon className='navIcon' />,
    },
    {
      key: 'ticket',
      text: 'Tickets',
      path: '/ticket',
      icon: <TicketControlIcon className='navIcon' />,
    },
    {
      key: 'archive',
      text: 'Archive',
      path: '/archive',
      icon: <ArchiveIcon className='navIcon' />,
    },

    {
      key: 'warrantee',
      text: 'Warrantee',
      path: '/warrantee',
      icon: <SerialControlTicket className='navIcon' />,
    },
    {
      key: 'customer',
      text: 'Customer',
      path: '/customer',
      icon: <TechnicalControlIcon className='navIcon' />,
    },
    {
      key: 'serial',
      text: 'Serial',
      path: '/serial',
      icon: <InboxIcon className='navIcon' />,
    },
  ];

  const techFields = [
    {
      key: 'tech-timeandattendance',
      text: 'Time and Attendance',
      path: '/tech/timeandattendance',
      icon: <TechTicketsIcon className='navIcon' />,
    },
    {
      key: 'tech-tickets',
      text: 'Tech Tickets',
      path: '/tech/tickets',
      icon: <TechTicketsIcon className='navIcon' />,
    },
  ];

  const reportFields = [
    {
      key: 'report-install_analysis',
      text: 'Install Analysis',
      path: '/reports/install_analysis',
      icon: <InstallReport className='navIcon' />,
    },
    {
      key: 'report-payroll',
      text: 'Payroll',
      path: '/reports/payroll',
      icon: <PayrollReport className='navIcon' />,
    },
    {
      key: 'report-spares_usage',
      text: 'Spares Usage',
      path: '/reports/spares_usage',
      icon: <SparesReport className='navIcon' />,
    },
    {
      key: 'report-bulk-usage',
      text: 'Bulk Data',
      path: '/reports/bulk_data',
      icon: <BulkReport className='navIcon' />,
    },
    {
      key: 'report-ticketing',
      text: 'Ticketing',
      path: '/reports/ticketing',
      icon: <TicketingReport className='navIcon' />,
    },
  ];

  const adminFields = [
    {
      key: 'constants',
      text: 'Constants',
      path: '/admin/constants',
      icon: <ConstantsIcon className='navIcon' />,
    },
    {
      key: 'consumables',
      text: 'Stock',
      path: '/admin/consumables',
      icon: <ConsumablesIcon className='navIcon' />,
    },
    {
      key: 't&a',
      text: 'Time & Attendance',
      path: '/admin/time&attendance',
      icon: <TechTicketsIcon className='navIcon' />,
    },
    {
      key: 'users',
      text: 'Users',
      path: '/admin/users',
      icon: <UsersIcon className='navIcon' />,
    },
  ];

  const selectedHandler = (path) => {
    switch (path) {
      case '/ticket/repair_ticket_edit':
        return '/ticket';
      case '/ticket/repair_ticket_auth':
        return '/ticket';
      case '/ticket/install_ticket_edit':
        return '/ticket';
      case '/ticket/install_ticket_auth':
        return '/ticket';
      case '/tech/tech_repair_ticket_view':
        return '/tech';
      case '/tech/tech_install_ticket_view':
        return '/tech';
      case '/customer/customer_new':
        return '/customer';
      case '/customer/customer_edit':
        return '/customer';
      case '/serial/serial_history':
        return '/serial';
      case '/admin/constants':
        return '/admin/constants';
      case '/admin/consumables':
        return '/admin/consumables';
      case '/admin/users':
        return '/admin/users';
      case '/admin/time&attendance':
        return '/admin/time&attendance';
      default:
        return path;
    }
  };

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: 'center',
          backgroundColor: '#354775',
          height: 100,
        }}
      >
        <Card
          className='multiClickDiv'
          sx={{
            background: 'none',
            maxWidth: 'fitContent',
            maxHeight: '100%',
            // padding: '1px',
            border: 'none',
            boxShadow: 'none',
            margin: ' 0 auto',
            width: 'fitContent !important',
          }}
          onClick={() => {
            // localStorage.getItem('Technician') === 'true'
            localStorage.getItem('type') === 'technician'
              ? navigate(`/tech/timeandattendance`, { replace: true })
              : navigate('/', true);
          }}
        >
          <img
            className='multiPic multiClickSmall'
            style={{ maxWidth: '50px', maxHeight: '100%', padding: '2px' }}
            src={logo}
            alt='logo'
          />
          <Typography
            className='multiClick multiClickSmall'
            xs={{ fontSize: '10px !important' }}
          >
            MultiClick
          </Typography>
        </Card>
      </Toolbar>
      <Divider />
      <Typography variant='h6' align='center'>
        MENU
      </Typography>
      <List
        sx={{
          justifyContent: 'center',
          backgroundColor: '#354775',
          // display: localStorage.getItem('Technician') === 'true' && 'none',
          display: localStorage.getItem('type') === 'technician' && 'none',
        }}
      >
        {fields.map((item) => {
          return (
            <ListItem key={item.key}>
              <ListItemButton
                disableGutters={true}
                disabled={
                  false
                  // item.key === 'tech' || item.key === 'ticket' ? true : false
                }
                selected={selectedHandler(location.pathname) === `${item.path}`}
                onClick={() => {
                  navigate(`/`, { replace: true });
                  navigate(`${item.path}`, { replace: true });
                }}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(100, 149, 237, 0.4) !important',
                  },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <List
        sx={{
          justifyContent: 'center',
          backgroundColor: '#354775',
          // display: localStorage.getItem('Technician') === 'false' && 'none',
          display: localStorage.getItem('type') !== 'technician' && 'none',
        }}
      >
        {techFields.map((item) => {
          return (
            <ListItem key={item.key}>
              <ListItemButton
                disableGutters={true}
                disabled={
                  false
                  // item.key === 'tech' || item.key === 'ticket' ? true : false
                }
                selected={selectedHandler(location.pathname) === `${item.path}`}
                onClick={() => {
                  navigate(`/`, { replace: true });
                  navigate(`${item.path}`, { replace: true });
                }}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(100, 149, 237, 0.4) !important',
                  },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Divider />
      <Typography
        variant='h6'
        align='center'
        sx={{
          display: localStorage.getItem('type') !== 'manager' && 'none',
        }}
      >
        ADMIN
      </Typography>
      <List
        sx={{
          justifyContent: 'center',
          backgroundColor: '#354775',
          display: localStorage.getItem('type') !== 'manager' && 'none',
        }}
      >
        {adminFields.map((item) => {
          return (
            <ListItem key={item.key}>
              <ListItemButton
                disableGutters={true}
                disabled={
                  false
                  // item.key === 'tech' || item.key === 'ticket' ? true : false
                }
                selected={selectedHandler(location.pathname) === `${item.path}`}
                onClick={() => {
                  navigate(`/`, { replace: true });
                  navigate(`${item.path}`, { replace: true });
                }}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(100, 149, 237, 0.4) !important',
                  },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Divider
        sx={{
          display: localStorage.getItem('type') !== 'manager' && 'none',
        }}
      />
      <Typography
        variant='h6'
        align='center'
        sx={{
          display: localStorage.getItem('type') !== 'manager' && 'none',
        }}
      >
        REPORTS
      </Typography>
      <List
        sx={{
          justifyContent: 'center',
          backgroundColor: '#354775',
          // display: localStorage.getItem('Technician') === 'true' && 'none',
          display: localStorage.getItem('type') !== 'manager' && 'none',
        }}
      >
        {reportFields.map((item) => {
          return (
            <ListItem key={item.key}>
              <ListItemButton
                disableGutters={true}
                disabled={
                  false
                  // item.key === 'tech' || item.key === 'ticket' ? true : false
                }
                selected={selectedHandler(location.pathname) === `${item.path}`}
                onClick={() => {
                  navigate(`/`, { replace: true });
                  navigate(`${item.path}`, { replace: true });
                }}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(100, 149, 237, 0.4) !important',
                  },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </>
  );
}

export default MainNavBar;
